import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { db } from "../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import BarLoader from "react-spinners/BarLoader";
// import { Button } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { EmblaCarousel } from "../../components/carousels/EmblaCarousel";

import { DateTime } from "luxon";

function DashboardPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const { t } = useTranslation("common");

  // Leaderboard aggregation runs on the client. Server-side cached leaderboard
  // is planned, but client aggregation remains enabled.

  // const AutoplayVideo = () => (
  //   <div
  //     style={{}}
  //     dangerouslySetInnerHTML={{
  //       __html: `
  //       <video loop muted autoPlay playsinline>
  //         <source src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fvideos%2FlandingPageBackground1_u6kvzp.mp4?alt=media&token=fd5fdea1-f06b-4042-b8ad-0c49aadf449b" type="video/mp4"/>
  //       </video>`
  //     }}
  //   />
  // )

  const [groups, setGroups] = useState();
  const fetchGroups = async () => {
    try {
      setIsLoading(true);

      let fetchedGroups = [];
      const q = query(collection(db, "groups"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newGroup = doc.data();
        fetchedGroups.push(newGroup);
      });

      // Trim groups payload to a minimal shape to avoid sending large nested arrays
      // into component state (which triggers heavy downstream work). When full
      // group data is required we fetch it locally in the consumer (see
      // fetchLeaderboardTopFifteen fallback below).
      const trimmed = fetchedGroups.map((g) => ({
        uid: g.uid,
        name: g.name,
        league: g.league,
        openingDateTime: g.openingDateTime,
        closingDateTime: g.closingDateTime,
        dateCreated: g.dateCreated,
      }));

      setGroups(trimmed);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching groups");
    }
  };

  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line
  }, []);

  const [leagues, setLeagues] = useState();
  const fetchLeagues = async () => {
    try {
      setIsLoading(true);

      let fetchedLeagues = [];
      const q = query(collection(db, "leagues"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newLeague = doc.data();
        fetchedLeagues.push(newLeague);
      });

      // console.log(fetchedLeagues);

      setLeagues(fetchedLeagues);

      // let orderedLeagues = [];

      // groups.forEach(group => {
      //   if (group.openingDateTime < new Date().toISOString()) return;
      //   if (orderedLeagues.some(e => e.name === group.league)){
      //     if (orderedLeagues.find(e => e.name === group.league).nextOpeningDateTime > group.openingDateTime){
      //       orderedLeagues.find(e => e.name === group.league).nextOpeningDateTime = group.openingDateTime;
      //     }
      //   } else {
      //     orderedLeagues.push({
      //       uid: fetchedLeagues.find(e => e.name === group.league)?.uid,
      //       name: group.league,
      //       image: fetchedLeagues.find(e => e.name === group.league)?.image,
      //       nextOpeningDateTime: group.openingDateTime
      //     });
      //   }
      // });

      // orderedLeagues.sort((a, b) => {
      //   return (new Date(a.nextOpeningDateTime)) - (new Date(b.nextOpeningDateTime));
      // });

      // setLeagues(orderedLeagues);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching leagues");
    }
  };

  useEffect(() => {
    if (groups) {
      fetchLeagues();
    }
    // eslint-disable-next-line
  }, [groups]);

  const [newsArticles, setNewsArticles] = useState();
  const fetchNewsArticles = async () => {
    try {
      setIsLoading(true);

      let fetchedNewsArticles = [];
      const q = query(collection(db, "newsArticles"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newNewsArticles = doc.data();
        fetchedNewsArticles.push(newNewsArticles);
      });

      // fetchedNewsArticles.sort((a, b) => {
      //   return (a.priceInTickets) - new Date(b.priceInTickets);
      // });

      setNewsArticles(fetchedNewsArticles);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching news articles");
    }
  };

  useEffect(() => {
    fetchNewsArticles();
    // eslint-disable-next-line
  }, []);

  // const [rewards, setRewards] = useState();
  // const fetchRewards = async () => {
  //   try {
  //     setIsLoading(true);

  //     let fetchedRewards = [];
  //     const q = query(collection(db, "rewards"));
  //     const docs = await getDocs(q);
  //     docs.forEach((doc) => {
  //       const newReward = doc.data()
  //       fetchedRewards.push(newReward);
  //     });

  //     fetchedRewards.sort((a, b) => {
  //       return (a.priceInTickets) - new Date(b.priceInTickets);
  //     });

  //     setRewards(fetchedRewards);

  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error(err);
  //     alert("An error occured while fetching products");
  //   }
  // };

  // useEffect(() => {
  //   fetchRewards();
  //   // eslint-disable-next-line
  // }, []);

  // function compareByPoints(a, b) {
  //   return b.total - a.total;
  // }

  // const getRoomMembers = (room, groupsForLookup) => {
  //   let fetchedRoomMembers = [...room.members];

  //   fetchedRoomMembers.forEach((member) => {
  //     let challengesWon = 0;
  //     let points = 0;
  //     let starPoints = 0;
  //     let total = 0;

  //     room?.submissions?.forEach((submission) => {
  //       if (submission.submitterUid === member.uid) {
  //         const group = (groupsForLookup || groups).find(
  //           (e) => e.uid === submission.groupUid
  //         );

  //         if (
  //           group?.dateCreated &&
  //           new Date(group.openingDateTime) >= new Date("July 1, 2025")
  //         ) {
  //           // Skip groups created after July 1, 2025
  //           let userChallengesWon = room?.challenges?.filter((e) =>
  //             e.bets.some(
  //               (b) => b.bettorUid === member.uid && b.result === e.result
  //             )
  //           ).length
  //             ? room?.challenges?.filter((e) =>
  //                 e.bets.some(
  //                   (b) => b.bettorUid === member.uid && b.result === e.result
  //                 )
  //               ).length
  //             : 0;

  //           let userPoints = 0;
  //           let userStarPoints = 0;

  //           if (room?.leagueSport === "RACING") {
  //             // console.log(submission?.positions.firstPolePositionDriver, group?.drivers.find(e => e.result === 'firstPolePosition')?.name)
  //             if (
  //               submission?.positions.firstPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "firstPolePosition")
  //                   ?.name ||
  //               submission?.positions.firstPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "secondPolePosition")
  //                   ?.name ||
  //               submission?.positions.firstPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "thirdPolePosition")
  //                   ?.name
  //             ) {
  //               userStarPoints += 2;
  //             }
  //             if (
  //               submission?.positions.secondPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "firstPolePosition")
  //                   ?.name ||
  //               submission?.positions.secondPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "secondPolePosition")
  //                   ?.name ||
  //               submission?.positions.secondPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "thirdPolePosition")
  //                   ?.name
  //             ) {
  //               userStarPoints += 2;
  //             }
  //             if (
  //               submission?.positions.thirdPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "firstPolePosition")
  //                   ?.name ||
  //               submission?.positions.thirdPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "secondPolePosition")
  //                   ?.name ||
  //               submission?.positions.thirdPolePositionDriver ===
  //                 group?.drivers.find((e) => e.result === "thirdPolePosition")
  //                   ?.name
  //             ) {
  //               userStarPoints += 2;
  //             }
  //             if (
  //               submission?.positions.fourthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fourthPlace")
  //                   ?.name ||
  //               submission?.positions.fourthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
  //               submission?.positions.fourthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
  //               submission?.positions.fourthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "seventhPlace")
  //                   ?.name ||
  //               submission?.positions.fourthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "eighthPlace")?.name
  //             ) {
  //               userPoints += 1;
  //             }
  //             if (
  //               submission?.positions.fifthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fourthPlace")
  //                   ?.name ||
  //               submission?.positions.fifthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
  //               submission?.positions.fifthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
  //               submission?.positions.fifthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "seventhPlace")
  //                   ?.name ||
  //               submission?.positions.fifthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "eighthPlace")?.name
  //             ) {
  //               userPoints += 1;
  //             }
  //             if (
  //               submission?.positions.sixthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fourthPlace")
  //                   ?.name ||
  //               submission?.positions.sixthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
  //               submission?.positions.sixthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
  //               submission?.positions.sixthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "seventhPlace")
  //                   ?.name ||
  //               submission?.positions.sixthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "eighthPlace")?.name
  //             ) {
  //               userPoints += 1;
  //             }
  //             if (
  //               submission?.positions.seventhPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fourthPlace")
  //                   ?.name ||
  //               submission?.positions.seventhPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
  //               submission?.positions.seventhPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
  //               submission?.positions.seventhPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "seventhPlace")
  //                   ?.name ||
  //               submission?.positions.seventhPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "eighthPlace")?.name
  //             ) {
  //               userPoints += 1;
  //             }
  //             if (
  //               submission?.positions.eighthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fourthPlace")
  //                   ?.name ||
  //               submission?.positions.eighthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
  //               submission?.positions.eighthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
  //               submission?.positions.eighthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "seventhPlace")
  //                   ?.name ||
  //               submission?.positions.eighthPlaceDriver ===
  //                 group?.drivers.find((e) => e.result === "eighthPlace")?.name
  //             ) {
  //               userPoints += 1;
  //             }
  //             if (
  //               submission?.positions.fastestLapDriver === group?.fastestLap
  //             ) {
  //               userPoints += 1;
  //             }
  //           } else {
  //             submission?.events.forEach((event) => {
  //               if (
  //                 event.selectedResult ===
  //                 group?.events.find(
  //                   (e) =>
  //                     e.homeTeam === event.homeTeam &&
  //                     e.awayTeam === event.awayTeam
  //                 )?.result
  //               ) {
  //                 if (event.isStarGame) {
  //                   if (
  //                     room.leagueName === "NBA" ||
  //                     room.leagueName === "MLB" ||
  //                     room.leagueName === "NHL"
  //                   ) {
  //                     userStarPoints += 1;
  //                   } else if (
  //                     room.leagueName === "NFL" ||
  //                     room.leagueName === "UFL"
  //                   ) {
  //                     userStarPoints += 4;
  //                   } else {
  //                     userStarPoints += 6;
  //                   }
  //                 } else {
  //                   if (
  //                     room.leagueName === "NBA" ||
  //                     room.leagueName === "MLB" ||
  //                     room.leagueName === "NHL"
  //                   ) {
  //                     userPoints += 0.25;
  //                   } else if (
  //                     room.leagueName === "NFL" ||
  //                     room.leagueName === "UFL"
  //                   ) {
  //                     userPoints += 2;
  //                   } else {
  //                     userPoints += 3;
  //                   }
  //                 }
  //               } else if (
  //                 group?.events.find(
  //                   (e) =>
  //                     e.homeTeam === event.homeTeam &&
  //                     e.awayTeam === event.awayTeam
  //                 )?.result === "Draw" &&
  //                 (event.selectedResult === "Home" ||
  //                   event.selectedResult === "Away")
  //               ) {
  //                 if (event.isStarGame) {
  //                   userStarPoints += 2;
  //                 } else {
  //                   userPoints += 1;
  //                 }
  //               }
  //             });
  //           }

  //           challengesWon = userChallengesWon;
  //           points += userPoints;
  //           starPoints += userStarPoints;
  //           total += userPoints + userStarPoints;
  //         }
  //       }
  //     });

  //     member.challengesWon = challengesWon;
  //     member.points = points;
  //     member.starPoints = starPoints;
  //     member.total = total;
  //     // if (member.name === "Jose Miguel" && roomUid === "5") {
  //     //   member.total += 71;
  //     // }
  //   });

  //   fetchedRoomMembers.sort(compareByPoints);
  //   fetchedRoomMembers.forEach((member, index) => {
  //     member.place = index + 1;
  //   });

  //   fetchedRoomMembers.forEach((member) => {
  //     let reward = getLeaderboardReward(
  //       member.place,
  //       fetchedRoomMembers.length * 4.99
  //     );

  //     member.reward = fetchedRoomMembers.length < 10 ? 0 : reward;
  //   });

  //   return fetchedRoomMembers;
  // };

  const [leaderboardTopFifteen, setLeaderboardTopFifteen] = useState();
  const fetchLeaderboardTopFifteen = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(
        "https://us-central1-sport-league-e35d7.cloudfunctions.net/getLeaderboardTop15Http"
      );
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }
      const data = await res.json();
      setLeaderboardTopFifteen(data.leaderboard || []);
    } catch (err) {
      console.error("Error fetching leaderboard:", err);
      alert("Failed to fetch leaderboard data. See console for details.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderboardTopFifteen();
  }, []);

  const getLeaderboardReward = (rank) => {
    switch (rank) {
      case 1:
        return "2100";
      case 2:
        return "1600";
      case 3:
        return "1100";
      case 4:
        return "1000";
      case 5:
        return "900";
      case 6:
        return "800";
      case 7:
        return "700";
      case 8:
        return "600";
      case 9:
        return "600";
      case 10:
        return "600";
      default:
        return "0";
    }
  };

  const [availableEvents, setAvailableEvents] = useState();
  const [comingSoonEvents, setComingSoonEvents] = useState();
  const fetchAvailableAndComingSoonEvents = async () => {
    try {
      setIsLoading(true);

      let fetchedAvailableEvents = [];
      let fetchedComingSoonEvents = [];

      const q = query(collection(db, "groups"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newGroup = doc.data();
        if (
          newGroup.openingDateTime < new Date().toISOString() &&
          newGroup.closingDateTime > new Date().toISOString()
        ) {
          fetchedAvailableEvents.push(newGroup);
        } else if (newGroup.openingDateTime > new Date().toISOString()) {
          fetchedComingSoonEvents.push(newGroup);
        }
      });

      fetchedAvailableEvents.sort((a, b) => {
        return new Date(a.openingDateTime) - new Date(b.openingDateTime);
      });

      fetchedComingSoonEvents.sort((a, b) => {
        return new Date(a.openingDateTime) - new Date(b.openingDateTime);
      });

      fetchedAvailableEvents.forEach((event) => {
        event.leagueImage = leagues?.find(
          (e) => e.name === event.league
        )?.image;
        event.leagueUid = leagues?.find((e) => e.name === event.league)?.uid;
      });

      fetchedComingSoonEvents.forEach((event) => {
        event.leagueImage = leagues?.find(
          (e) => e.name === event.league
        )?.image;
        event.leagueUid = leagues?.find((e) => e.name === event.league)?.uid;
      });

      // Deduplicate events by league (groups are created per tournament type;
      // we want to show a single representative per league on the dashboard)
      const dedupeByLeague = (arr) => {
        const map = new Map();
        arr.forEach((ev) => {
          const key = ev.leagueUid || ev.league;
          if (!map.has(key)) {
            map.set(key, ev);
          } else {
            // Keep the event with the earliest openingDateTime
            const existing = map.get(key);
            if (
              new Date(ev.openingDateTime) < new Date(existing.openingDateTime)
            ) {
              map.set(key, ev);
            }
          }
        });
        return Array.from(map.values());
      };

      setAvailableEvents(dedupeByLeague(fetchedAvailableEvents));
      setComingSoonEvents(dedupeByLeague(fetchedComingSoonEvents));

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching available events");
    }
  };

  useEffect(() => {
    if (leagues) {
      fetchAvailableAndComingSoonEvents();
    }
    // eslint-disable-next-line
  }, [leagues]);

  const [stats, setStats] = useState([
    // {
    //   sportName: 'Football',
    //   leagues: [
    //     {
    //       name: 'Premier League',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'La Liga',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'Serie A',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'Bundesliga',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'Ligue 1',
    //       memberCount: 20
    //     }
    //   ]
    // },
    // {
    //   sportName: 'Basketball',
    //   leagues: [
    //     {
    //       name: 'NBA',
    //       memberCount: 30
    //     },
    //     {
    //       name: 'Euroleague',
    //       memberCount: 16
    //     },
    //     {
    //       name: 'ACB',
    //       memberCount: 18
    //     },
    //     {
    //       name: 'VTB United League',
    //       memberCount: 13
    //     },
    //     {
    //       name: 'LNB Pro A',
    //       memberCount: 18
    //     }
    //   ]
    // },
    // {
    //   sportName: 'Tennis',
    //   leagues: [
    //     {
    //       name: 'ATP',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'WTA',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'Grand Slam',
    //       memberCount: 4
    //     },
    //     {
    //       name: 'ATP Challenger',
    //       memberCount: 20
    //     },
    //     {
    //       name: 'WTA Challenger',
    //       memberCount: 20
    //     }
    //   ]
    // }
  ]);

  const fetchStats = async () => {
    try {
      setIsLoading(true);

      let fetchedStats = [];

      const q = query(collection(db, "rooms"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newRoom = doc.data();

        if (newRoom.isActive) {
          if (fetchedStats.some((e) => e.sportName === newRoom.leagueSport)) {
            if (
              fetchedStats
                .find((e) => e.sportName === newRoom.leagueSport)
                .leagues.some((e) => e.name === newRoom.leagueName)
            ) {
              fetchedStats
                .find((e) => e.sportName === newRoom.leagueSport)
                .leagues.find(
                  (e) => e.name === newRoom.leagueName
                ).memberCount += newRoom.members.length;
            } else {
              fetchedStats
                .find((e) => e.sportName === newRoom.leagueSport)
                .leagues.push({
                  name: newRoom.leagueName,
                  memberCount: newRoom.members.length,
                });
            }
          } else {
            fetchedStats.push({
              sportName: newRoom.leagueSport,
              leagues: [
                {
                  name: newRoom.leagueName,
                  memberCount: newRoom.members.length,
                },
              ],
            });
          }
        }
      });

      fetchedStats.sort((a, b) => {
        return (
          b.leagues.reduce((acc, e) => acc + e.memberCount, 0) -
          a.leagues.reduce((acc, e) => acc + e.memberCount, 0)
        );
      });

      setStats(fetchedStats);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching stats");
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line
  }, []);

  const handleCurrentSeason = async () => {
    try {
      setIsLoading(true);
      const q = query(
        collection(db, "mainLeaderboardSeasons"),
        where("status", "==", "Active")
      );
      const docs = await getDocs(q);
      if (docs.docs.length > 0) {
        const currentSeason = docs.docs[0].data();

        // Get current date in El Salvador time zone (America/El_Salvador)
        const nowInElSalvador = DateTime.now().setZone("America/El_Salvador");
        // Parse your target date also in El Salvador time zone
        const targetDate = DateTime.fromISO(currentSeason.endDate, {
          zone: "America/El_Salvador",
        });

        if (
          nowInElSalvador.toFormat("yyyy-MM-dd") ===
          targetDate.toFormat("yyyy-MM-dd")
        ) {
          leaderboardTopFifteen.forEach(async (user) => {
            if (user.reward > 0) {
              const userRef = query(
                collection(db, "users"),
                where("uid", "==", user.uid)
              );
              const findUser = await getDocs(userRef);
              findUser.forEach(async (userObject) => {
                const getUser = doc(db, "users", userObject.id);
                const userData = userObject.data();
                if (!currentSeason.ticketsHaveBeenRewarded) {
                  await updateDoc(getUser, {
                    tickets: userData.tickets + parseFloat(user.reward),
                  });
                }
              });
            }
          });

          // Deactivate old season
          const seasonRef = query(
            collection(db, "mainLeaderboardSeasons"),
            where("uid", "==", currentSeason.uid)
          );
          const findSeason = await getDocs(seasonRef);
          findSeason.forEach(async (seasonObject) => {
            const getSeason = doc(
              db,
              "mainLeaderboardSeasons",
              seasonObject.id
            );
            await updateDoc(getSeason, {
              status: "Inactive",
              ticketsHaveBeenRewarded: true,
            });
          });

          // Activate new season
          const newSeasonUid = parseInt(currentSeason.uid) + 1;
          const newSeasonRef = query(
            collection(db, "mainLeaderboardSeasons"),
            where("uid", "==", newSeasonUid.toString())
          );
          const findNewSeason = await getDocs(newSeasonRef);
          findNewSeason.forEach(async (newSeasonObject) => {
            const getNewSeason = doc(
              db,
              "mainLeaderboardSeasons",
              newSeasonObject.id
            );
            await updateDoc(getNewSeason, {
              status: "Active",
            });
          });
        }
      }
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching current season");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (leaderboardTopFifteen) {
      handleCurrentSeason();
    }
    // eslint-disable-next-line
  }, [leaderboardTopFifteen]);

  const getActiveMembershipTierIcon = (tier) => {
    switch (tier) {
      case "platinum":
        return "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbadges%2FMultiplicador%202x%20Platinum.png?alt=media&token=41617020-aeb0-44dc-9d4f-5c32bc47b9df";
      case "gold":
        return "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbadges%2FMultiplicador%202x%20Gold.png?alt=media&token=90bc68dd-b55c-4ad9-bfd8-5ef9a1a9d192";
      default:
        return null;
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div
      id="dashboardPage"
      className="page"
      style={{
        padding: 0,
        //  marginBottom: -75
      }}
    >
      <section id="heroSection">
        <EmblaCarousel />
        {/* <ScrollMenu>
          <img
            className='heroBannerContainer'
            alt="heroImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2FB01-ENG-1900X15001.png?alt=media&token=016d9df0-66cd-4f59-83f8-2ebc42c2d905"
          />
          <img
            className='heroBannerContainer'
            alt="heroImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2FB03-ENG-1900X1500.png?alt=media&token=9842d674-b0cc-4b84-b3de-4019ec8146a3"
            style={{marginRight: '1rem'}}
          />
        </ScrollMenu> */}
      </section>
      {/* LATEST RESULTS SECTION */}
      {/* <section id='latestResultsSection'>
        <h1>
          LATEST RESULTS
        </h1>
        <div id='latestResultsContainer'>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <div className='hideOnMobile'>
            <h3 style={{textAlign: 'right'}}>
              TEAM NAME
            </h3>
            <div style={{borderBottom: '5px solid #005EE1', marginTop: '1rem', marginBottom: '1rem'}}></div>
            <h3 className='winOrLoseText' style={{textAlign: 'right'}}>
              WIN
            </h3>
            </div>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                className="hideOnMobile"
                id="latestResultsLeftTeamImage"
              />
          </div>
          <div id='latestResultsMiddleCOntainer'>
            <h3>
              LEAGUE
            </h3>
            <div id='latestResultsResultContainer' className='hideOnMobile'>
              <div style={{marginRight: '1rem'}}>
                <h1>
                  0
                </h1>
              </div>
              <h1>
                VS
              </h1>
              <div style={{marginLeft: '1rem'}}>
                <h1>
                  0
                </h1>
              </div>
            </div>
            <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '0.5rem', marginBottom: '0.5rem'}} className='hideOnDesktop'>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <h1 className='result'>1</h1>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginLeft: '1rem' }}
              />
              </div>
              <div style={{marginLeft: '1rem', marginRight: '1rem'}}>
                <h1>
                  VS
                </h1>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginRight: '1rem' }}
              />
              <h1 className='result'>0</h1>
              </div>
            </div>
            </div>
            <h4 id='latestResultsDateAndTime'>
              {new Date().toLocaleTimeString("en-US", {weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"})}
            </h4>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <img
              alt="fotoDePerfil"
              src="https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"
              style={{
                height: 75,
              }}
              id='latestResultsRightTeamImage'
              className='hideOnMobile'
            />
            <div className='hideOnMobile'>
            <h3 style={{textAlign: 'left'}}>
              TEAM NAME
            </h3>
            <div style={{borderBottom: '5px solid #005EE1', marginTop: '1rem', marginBottom: '1rem'}}></div>
            <h3 className='winOrLoseText' style={{textAlign: 'left'}}>
              LOSE
            </h3>
            </div>
          </div>
        </div>
      </section> */}
      {/* NEXT MATCH AND LEADERBOARDS SECTION */}
      <section id="nextMatchAndLeaderboardsSection">
        <div id="nextMatchContainer">
          <h1>{t("availableEvents").toUpperCase()}</h1>
          <ScrollMenu>
            {availableEvents?.map((event) => {
              return (
                <a
                  key={
                    event.uid || `${event.leagueUid}-${event.openingDateTime}`
                  }
                  href={`/play/leagues/${event.leagueUid}`}
                  className="dashboardLeagueContainer"
                >
                  <img alt="leagueImage" src={event.leagueImage} />
                  <p className="dashboardLeagueName">{event.league}</p>
                  <p className="dashboardLeagueNextOpeningDate">{event.name}</p>
                  <p className="dashboardLeagueNextOpeningDate">
                    {new Date(event.openingDateTime).toLocaleDateString()} -{" "}
                    {new Date(event.closingDateTime).toLocaleDateString()}
                  </p>
                </a>
              );
            })}
          </ScrollMenu>
        </div>
        <div id="nextMatchContainer">
          <h1>{t("comingSoon").toUpperCase()}</h1>
          <ScrollMenu>
            {comingSoonEvents?.map((event) => {
              return (
                <a
                  key={
                    event.uid || `${event.leagueUid}-${event.openingDateTime}`
                  }
                  href={`/play/leagues/${event.leagueUid}`}
                  className="dashboardLeagueContainer"
                >
                  <img alt="leagueImage" src={event.leagueImage} />
                  <p className="dashboardLeagueName">{event.league}</p>
                  <p className="dashboardLeagueNextOpeningDate">{event.name}</p>
                  <p className="dashboardLeagueNextOpeningDate">
                    {new Date(event.openingDateTime).toLocaleDateString()} -{" "}
                    {new Date(event.closingDateTime).toLocaleDateString()}
                  </p>
                </a>
              );
            })}
          </ScrollMenu>
        </div>
        <div id="leaderboardsContainer">
          <h1>{t("leaderboard").toUpperCase()}</h1>
          <p style={{ color: "#FFFFFF", marginBottom: "0.5rem" }}>
            OPENS 1/07/2025 - CLOSES 30/06/2026
          </p>
          <div className="leaderboardsInnerContainer hideOnMobile">
            <div id="leaderboardsHeader">
              <h4 className="leaderboardsId">{t("place").toUpperCase()}</h4>
              <h4 className="leaderboardsUsername">
                {t("username").toUpperCase()}
              </h4>
              <h4 className="leaderboardsCw">
                {t("challengesWon").toUpperCase()}
              </h4>
              <h4 className="leaderboardsTotalChampionPoints">
                {t("totalChampionPoints").toUpperCase()}
              </h4>
              <h4 className="leaderboardsReward">
                {t("reward").toUpperCase()}
              </h4>
            </div>
            {leaderboardTopFifteen?.length > 0 ? (
              leaderboardTopFifteen?.map((user, index) => {
                return (
                  <div
                    key={user.uid || user.name || index}
                    className="leaderboardsRow"
                  >
                    <p className="leaderboardsId">{index + 1}</p>
                    <p className="leaderboardsUsername">
                      {user.membershipTier && (
                        <img
                          alt="badge"
                          src={getActiveMembershipTierIcon(user.membershipTier)}
                          style={{
                            width: 25,
                            height: "auto",
                            backgroundColor: "transparent",
                            marginRight: "0.5rem",
                          }}
                        />
                      )}
                      {user.name}
                    </p>
                    <p className="leaderboardsCw">{user.challengesWon}</p>
                    <p className="leaderboardsTotalChampionPoints">
                      {user.total}
                    </p>
                    <p className="leaderboardsReward">
                      {getLeaderboardReward(index + 1)}
                    </p>
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                  marginTop: "1rem",
                }}
              >
                None ranking yet
              </p>
            )}
          </div>
          <ScrollMenu>
            <div className="leaderboardsInnerContainer hideOnDesktop">
              <div id="leaderboardsHeader">
                <h4 className="leaderboardsId">{t("place").toUpperCase()}</h4>
                <h4 className="leaderboardsUsername">
                  {t("username").toUpperCase()}
                </h4>
                <h4 className="leaderboardsCw">
                  {t("challengesWon").toUpperCase()}
                </h4>
                <h4 className="leaderboardsTotalChampionPoints">
                  {t("totalChampionPoints").toUpperCase()}
                </h4>
                <h4 className="leaderboardsReward">
                  {t("reward").toUpperCase()}
                </h4>
              </div>
              {leaderboardTopFifteen?.length > 0 ? (
                leaderboardTopFifteen?.map((user, index) => {
                  return (
                    <div
                      key={user.uid || user.name || index}
                      className="leaderboardsRow"
                    >
                      <p className="leaderboardsId">{index + 1}</p>
                      <p className="leaderboardsUsername">
                        {user.membershipTier && (
                          <img
                            alt="badge"
                            src={getActiveMembershipTierIcon(
                              user.membershipTier
                            )}
                            style={{
                              width: 25,
                              height: "auto",
                              backgroundColor: "transparent",
                              marginRight: "0.5rem",
                            }}
                          />
                        )}
                        {user.name}
                      </p>
                      <p className="leaderboardsCw">{user.challengesWon}</p>
                      <p className="leaderboardsTotalChampionPoints">
                        {user.total}
                      </p>
                      <p className="leaderboardsReward">
                        {getLeaderboardReward(index + 1)}
                      </p>
                    </div>
                  );
                })
              ) : (
                <p
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    marginTop: "1rem",
                  }}
                >
                  None ranking yet
                </p>
              )}
            </div>
          </ScrollMenu>
        </div>
      </section>
      {/* MOST POPULAR LEAGUES SECTION */}
      {/* <section id='mostPopularLeaguesSection'>
        <h1>
          MOST POPULAR LEAGUES
        </h1>
        <div id='mostPopularLeaguesInnerContainer'>
          <div className='mostPopularLeagueCard'>
            <h3>
              LEAGUE
            </h3>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginRight: '1rem' }}
              />
              <div>
                <h1>
                  VS
                </h1>
              </div>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginLeft: '1rem' }}
              />
            </div>
            <h4>
              {new Date().toLocaleTimeString("en-US", {weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"})}
            </h4>
            <Button className='primaryBtn'>
              PLAY GAME
            </Button>
          </div>
          <div className='mostPopularLeagueCard'>
            <h3>
              LEAGUE
            </h3>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginRight: '1rem' }}
              />
              <div>
                <h1>
                  VS
                </h1>
              </div>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginLeft: '1rem' }}
              />
            </div>
            <h4>
              {new Date().toLocaleTimeString("en-US", {weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"})}
            </h4>
            <Button className='primaryBtn'>
              PLAY GAME
            </Button>
          </div>
          <div className='mostPopularLeagueCard'>
            <h3>
              LEAGUE
            </h3>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginRight: '1rem' }}
              />
              <div>
                <h1>
                  VS
                </h1>
              </div>
              <Avatar
                alt="team-avatar"
                src={"https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"}
                size={75}
                style={{ marginLeft: '1rem' }}
              />
            </div>
            <h4>
              {new Date().toLocaleTimeString("en-US", {weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"})}
            </h4>
            <Button className='primaryBtn'>
              PLAY GAME
            </Button>
          </div>
        </div>
      </section> */}
      {/* LATEST NEWS AND ARTICLES SECTION */}
      <section id="latestNewsAndArticlesSection">
        <h1>{t("latestNewsAndArticles").toUpperCase()}</h1>
        <div style={{ marginTop: "1rem" }}>
          <ScrollMenu>
            {
              // eslint-disable-next-line
              newsArticles?.map((newsArticle) => {
                if (newsArticle?.type === "main") {
                  return (
                    <div
                      key={newsArticle.uid || newsArticle.title}
                      onClick={() =>
                        navigate(`news/articles/${newsArticle.uid}`)
                      }
                      className="newsCard"
                    >
                      <div className="newsCardImageContainer">
                        <img
                          alt="newsImage"
                          src={
                            newsArticle?.image
                              ? newsArticle.image
                              : "https://res.cloudinary.com/da3qtg7t5/image/upload/v1690500453/General%20use/placeholder-image_j2eqmr.png"
                          }
                        />
                      </div>
                      <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                        <p className="newsCardTitle">{newsArticle?.title}</p>
                      </div>
                    </div>
                  );
                }
              })
            }
            {
              // eslint-disable-next-line
              newsArticles?.map((newsArticle) => {
                if (newsArticle?.type !== "main") {
                  return (
                    <div
                      key={newsArticle.uid || newsArticle.title}
                      onClick={() =>
                        navigate(`news/articles/${newsArticle.uid}`)
                      }
                      className="newsCard"
                    >
                      <div className="newsCardImageContainer">
                        <img
                          alt="newsImage"
                          src={
                            newsArticle?.image
                              ? newsArticle.image
                              : "https://res.cloudinary.com/da3qtg7t5/image/upload/v1690500453/General%20use/placeholder-image_j2eqmr.png"
                          }
                        />
                      </div>
                      <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                        <p className="newsCardTitle">{newsArticle?.title}</p>
                      </div>
                    </div>
                  );
                }
              })
            }
          </ScrollMenu>
        </div>
      </section>
      {/* STATS SECTION */}
      <section id="statsSection">
        <h1>STATS</h1>
        <div style={{ marginTop: "1rem" }}>
          <ScrollMenu>
            {
              // eslint-disable-next-line
              stats?.map((stat) => {
                return (
                  <div key={stat.sportName} className="statCard">
                    <p className="statSportName">
                      {stat?.sportName?.toUpperCase()}
                    </p>
                    <div className="statLeaguesListHeader">
                      <p>{t("leagues").toUpperCase()}</p>
                      <p>{t("members").toUpperCase()}</p>
                    </div>
                    {stat.leagues.map((league) => {
                      return (
                        <div key={league.name} className="statLeaguesListItem">
                          <p>{league.name}</p>
                          <p>{league.memberCount}</p>
                        </div>
                      );
                    })}
                  </div>
                );
              })
            }
          </ScrollMenu>
        </div>
      </section>
    </div>
  );
}

export default DashboardPage;
